import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export var marginVerticalNegative = byMedia(function (value) {
  return "\n    margin-top: -" + getPx(value) + ";\n    margin-bottom: -" + getPx(value) + ";\n  ";
});
export var marginVerticalHalfNegative = byMedia(function (value) {
  return "\n    margin-top: calc(-" + getPx(value) + " / 2);\n    margin-bottom: calc(-" + getPx(value) + " / 2);\n  ";
});